import React, {useState} from 'react';
import CardAvailableList from './cardAvailableList';
import Pagination from './pagination';
import './NFTMarket.css';
import LazyLoad from "react-lazyload";
import {Link} from "react-router-dom";

const NFTMarketPlace = ({loading, 
                        error, 
                        data, 
                        localData, 
                        fetchingCardsRule, 
                        sliceStart, 
                        sliceEnd, 
                        displayCollectionName, 
                        collectionName, 
                        displayPagination, 
                        displayLink, 
                        linkAddress, 
                        linkTitle}) => {
  const [isExternalDataLoaded, setExternalDAtaLoaded] = useState(false)
  const newLocalFilteredData = localData && localData.filter(fetchingCardsRule).slice(sliceStart, sliceEnd);
  const newFilteredData = data && data.filter(fetchingCardsRule).slice(sliceStart, sliceEnd);
  async function returnTrue() {
    let promise = new Promise((resolve, reject) => {
      setTimeout(() => resolve(true), 2000) // resolve
    });
    let result = await promise;
    setExternalDAtaLoaded(result);
  }
  // call the function
  returnTrue();
  const filteredDataMerged = isExternalDataLoaded ? (newLocalFilteredData.splice(newFilteredData)) : returnTrue();
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(12);
  const lastPage = Math.floor(Object.values(filteredDataMerged).length/cardsPerPage) + 1;
  return (
    <div id="NFTMarketPlace" className="NFTMarketPlace pa4 bg-black">
      <div className="slider-items w-100">
        <div className='slide-item'>
          <h1 className={`fw1 white f2 pb3 ${displayCollectionName} pt3 mt4 ml3 text-cent pl2 bg-black`}>{collectionName}</h1>
          <LazyLoad height={50}>
            <div style={{color: "white"}} className='pt3 pb5 bg-black production grid-card-nft'>
              {loading && <div>A moment please...</div>}
              {error && (
                <div style={{color: "white"}}> {`There is a problem fetching the data - ${error}`}</div>
              )}
              <CardAvailableList cards = {Object.values(filteredDataMerged)} currentPage = {currentPage} cardsPerPage = {cardsPerPage} />
            </div>
          </LazyLoad>
          <div className={`category-link ${displayLink}`}><Link to={linkAddress}>{linkTitle}</Link>
          </div>
        </div>
      </div>
      <div className={`${displayPagination} direction pt5 ph2 pb4 white f2`}>
        <Pagination totalCards={Object.values(filteredDataMerged).length} currentPage={currentPage} setCurrentPage={setCurrentPage} cardsPerPage={cardsPerPage} lastPage ={lastPage}/>
      </div>
    </div>
  );
};

export default NFTMarketPlace;